/** Approved Cyra artwork. CSS follows the existing saved theme without extra state. */
export function BrandLogo({ inverse = false }: { inverse?: boolean }) {
  return (
    <span className="cyra-logo" data-inverse={inverse || undefined}>
      <img className="cyra-logo-light" src="/brand/logo-light.svg" alt="Cyra" />
      <img className="cyra-logo-dark" src="/brand/logo-dark.svg" alt="Cyra" />
    </span>
  );
}
